<template>
  <main :class="dynamic_row ? 'row' : ''">
    <div :class="dynamic_class ? 'col-md-10' : 'row'" style="margin-top:70px">
      <div class="container-fluid">
        <div class="row mb-4">
          <div v-if="loading" class="text-center col-sm-12">
            <sweetalert-icon class="text-center" :icon="loadingType" />
            {{ loadingMessage }}
          </div>
          <div
            v-for="order in products"
            :key="order.id"
            class="col-md-3 col-sm-10"
            v-else
          >
            <div class="card mt-3">
              <img
                class="card-img-top mt-3"
                style="width: 100%;"
                :src="order.image"
                :alt="order.name + ' AamCart.com'"
              />
            </div>
            <div class="product-other text-center">
              <h3 class="name">
                {{ order.name }}
              </h3>
              <span class="mb-2">
                Sold By
                <router-link
                  :to="'/vendorProfile/' + vendorProducts[0].vendorId"
                  >{{ getSellerName(vendorProducts[0].vendorId) }}</router-link
                >
              </span>
              <div v-if="CheckVendorProduct(order.id)">
                <h3 class="price">
                  ₹ {{ getVendorProduct(order.id, "sellprice") }}
                </h3>
                <span class="cart-add" v-if="vendorProducts[0].stock > 0">
                  <i
                    class="btn btn-sm btn-circle fa fa-minus"
                    style="background-color:#D0D0D2; color:#1A1824;"
                    v-if="user"
                    @click="
                      addToCart(
                        getVendorProduct(order.id, 'id'),
                        order.id,
                        getCart(order.id, 'qty', carts),
                        order.unitType,
                        getVendorProduct(order.id, 'sellprice'),
                        'minus',
                        user.uid,
                        getVendorProduct(order.productId, 'vendorId')
                      )
                    "
                  ></i>
                  <span v-else>
                    <router-link to="/login">
                      <i
                        class="btn btn-sm btn-circle fa fa-minus"
                        style="background-color:#D0D0D2; color:#1A1824
                        "
                      ></i>
                    </router-link>
                  </span>
                  <span style="padding:5px;">
                    {{ getCart(order.id, "qty", carts) }}
                    {{ order.unitType }}
                  </span>
                  <i
                    class="btn btn-sm btn-circle fa fa-plus"
                    style="background-color:#51381b ; color:#FFFFFF;"
                    v-if="user"
                    @click="
                      addToCart(
                        getVendorProduct(order.id, 'id'),
                        order.id,
                        getCart(order.id, 'qty', carts),
                        order.unitType,
                        getVendorProduct(order.id, 'sellprice'),
                        'plus',
                        user.uid,
                        getVendorProduct(order.productId, 'vendorId')
                      )
                    "
                  ></i>
                  <span v-else>
                    <router-link to="/login">
                      <i
                        class="btn btn-sm btn-circle fa fa-plus"
                        style="background-color:#51381b ; color:#FFFFFF;"
                      ></i>
                    </router-link>
                  </span>
                </span>
                <span v-else>
                  <h3 style="font-size:16px" class="text-danger">
                    Out of Stock
                  </h3>
                </span>
              </div>
              <div v-else>
                <h3 style="font-size:16px" class="text-danger">
                  Currently Unavailable
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-if="products.length == 0 && loading == false"
        class=" col-md-12 text-center"
      >
        <div class="text-center">
          <h3>Product Not Found</h3>
        </div>
      </div>
      <Category class="pt-5 pb-5" />
    </div>
    <div
      class="col-md-2 media-query"
      v-if="user"
      style="background-color:#E7E7E7"
    >
      <Cart />
    </div>
  </main>
</template>

<script>
import Category from "../components/Category";
import { dbFs, db } from "@/modules/database";
import Cart from "@/components/Cart.vue";
import { mapGetters } from "vuex";
import { addToCart } from "@/modules/cart";

export default {
  data() {
    return {
      loading: false,
      dynamic_class: false,
      class: "col-md-8",
      dynamic_row: false,
      keyword: this.$route.params.keyword,
      products: [],
      vendors: [],
      productIdList: [],
      vendorProducts: [],
      carts: []
    };
  },
  mounted() {
    this.setupFirebaseReading();
    this.AddDynamicClass();
    this.getAllVendor();
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  components: {
    Cart,
    Category
  },
  methods: {
    setupFirebaseReading: function() {
      this.loading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Product Loading";
      this.$bind(
        "products",
        dbFs.collection("products").where("productId", "==", this.keyword)
      )
        .then(() => {
          this.getVendorProductData();
          this.getCartData();
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getAllVendor() {
      this.$bind("vendors", dbFs.collection("vendor")).catch(error => {
        console.log(error);
      });
    },
    getSellerName(id) {
      let seller = "Not Found";
      for (const cusKey of Object.keys(this.vendors)) {
        const product = this.vendors[cusKey];
        if (id == product.id) {
          seller = product.shopDetails.name;
        }
      }
      return seller;
    },
    getVendorProductData() {
      this.loading = true;
      this.loadingType = "loading";
      this.loadingMessage = "Product Loading";
      this.$bind(
        "vendorProducts",
        dbFs
          .collection("vendorProducts")
          .where("status", "==", true)
          .where("productsId", "==", this.keyword)
      )
        .then(() => {})
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    AddDynamicClass() {
      if (this.user) {
        this.dynamic_class = "col-md-10";
        this.dynamic_row = "row";
      } else {
        this.dynamic_class = "";
        this.dynamic_row = "";
      }
    },
    getCartData() {
      this.loading = true;
      if (this.user) {
        this.$rtdbBind("carts", db.ref("carts/" + this.user.uid))
          .then(() => {
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
            console.log(error);
            this.loadingError = true;
          });
      }
    },
    getCart(id, dataType) {
      let productDetails = {
        qty: 0,
        price: 0
      };
      this.carts.forEach(cart => {
        if (id == cart.productId) {
          productDetails = cart;
        }
      });
      if (dataType == "qty") {
        return productDetails.qty;
      }
      if (dataType == "price") {
        return productDetails.price;
      }
    },
    getVendorProduct(id, dataType) {
      let productDetails = {
        sellPrice: 0,
        stock: 0,
        moq: 0,
        vendorId: ""
      };
      for (const cusKey of Object.keys(this.vendorProducts)) {
        const product = this.vendorProducts[cusKey];
        if (id == product.productsId) {
          productDetails = product;
        }
      }
      if (dataType == "sellprice") {
        return productDetails.sellPrice;
      }
      if (dataType == "stock") {
        return productDetails.stock;
      }
      if (dataType == "moq") {
        return productDetails.moq;
      }
      if (dataType == "id") {
        return productDetails.id;
      }
      if (dataType == "vendorId") {
        return productDetails.vendorId;
      }
    },
    CheckVendorProduct(id) {
      for (const cusKey of Object.keys(this.vendorProducts)) {
        const product = this.vendorProducts[cusKey];
        if (id == product.productsId) {
          return true;
        }
      }
    },
    addToCart
  },
  watch: {
    user() {
      this.dynamic_class = !this.dynamic_class;
      this.dynamic_row = !this.dynamic_row;
    }
  }
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@700&display=swap");
.slide-bar-view {
  margin-left: 130px;
  margin-right: 130px;
}
.add-to-cart {
  padding-top: 15px;
  padding-bottom: 20px;
}
.add-to-cart button {
  width: 120px;
  height: 42px;
  border-radius: 33px;
}
.cart-add {
  font-size: 15px;
  color: #000000;
}
.product-other .name {
  font-size: 17px;
  font-family: "Montserrat", sans-serif;
  color: #000000;
}
.product-other .price {
  font-size: 17px;
  font-family: "Montserrat", sans-serif;
  letter-spacing: 1.2px;
  color: #51381b;
}
.product-other {
  padding-top: 15px;
}
.product-images {
  width: 215px;
  box-shadow: 0px 3px 10px #00000029;
  border-radius: 0px;
}
.product-images img {
  margin: auto;
}
.product-box {
  border-radius: 0px !important;
  padding-top: 20px;
  width: 215px;
}
.btn-for-box {
  width: 257px;
  height: 85px;
  background-color: #1c1a1a;
  opacity: 0.8;
  border-radius: 33px;
  backdrop-filter: blur(9px);
}
.btn-for-box h4 {
  font-size: 22px;
  font-family: "Pacifico", cursive;
  color: #ffffff;
  letter-spacing: 2.88px;
  padding-top: 15px;
  text-align: center;
}
.btn-for-box p {
  font-size: 16px;
  font-family: "Montserrat-Regular";
  color: #ffffff;
  letter-spacing: 0.51px;
  /* padding-top: 5px; */
  text-align: center;
}
.category-wise-item {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
}
.category-wise-item .category-name {
  font-size: 34px;
  font-family: "Montserrat-Regular";
  color: #313131;
  font-weight: bold;
}
.category-list {
  margin-left: 20px;
  margin-right: 20px;
}
.categoryImage {
  width: 376px;
  height: 242px;
}
.category {
  margin-left: 15px;
  margin-right: 15px;
}
.category-box-1 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/1.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-2 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/2.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-3 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/3.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-4 {
  padding: 0px;
  height: 242px;
  background-image: url("../assets/category/4.png");
  background-repeat: no-repeat;
  background-size: auto;
}
.category-box-inside:hover {
  background-color: #51381b;
  opacity: 0.9;
  margin: auto;
}
.category-box-inside {
  height: 100%;
  /* margin: auto; */
  padding-top: 25%;
  padding-left: 45px;
  padding-right: 25%;
  /* padding-bottom: 76px; */
}
.primary-color {
  color: #17aa18;
}
@media only screen and (max-width: 768px) {
  .media-query {
    display: none;
  }
}
</style>
